import StaleCache from 'stale-lru-cache';

export class DeliveryReturnsCache {
    constructor() {
        this.cache = new StaleCache({
            maxSize: 1,
            maxAge: 60 * 60 * 24, // 1 day
        });
    }

    generateKey(brandId, country, language) {
        return `${brandId}-${country}-${language}`;
    }

    get(key) {
        return this.cache.get(key);
    }

    set(key, data) {
        this.cache.set(key, data);
    }
}

export const deliveryReturnsCache = new DeliveryReturnsCache();
